import Client from '../axiosClient'
const resource = '/subscription';
const resourceInit = '/subscription_initialize';
const resourceUpdateStatus = 'subscription_status_update';
export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get(payload) {
    if(payload) {
      return Client.get(`${resource}?page=${payload['page']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);

  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },

  sendMail(payload) {
    return Client.post(`${resourceMail}`, payload);
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
};




// WEBPACK FOOTER //
// ./src/repositories/events/subscriptionRepository.js